import React from "react";
import Movesizelist from "./components/movesizelist";
import { withRouter } from "react-router-dom";
function Movesize() {
  return <Movesizelist></Movesizelist>;
}
export default withRouter(Movesize);
